import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'react-emotion'
import ReactMarkdown from 'react-markdown'
import { Svg } from '../../application'
import { colors } from '../../styles'
import getText from '../strings'

const Message = styled('div')`
  border: 1px solid;
  width: 80%;
  margin: 10px auto;
  padding: 15px;
  border-radius: 4px;
  background-color: ${(props) => (props.error ? colors.error_bg : colors.tui_blue_25)};
  border-color: ${(props) => (props.error ? colors.error_border : colors.tui_dark_blue)};
`

const Break = styled('div')`
  flex-basis: 100%;
  height: 0;
`

const Button = styled('button')`
  width: 100%;
`

const Flex = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  p {
    margin-bottom: 20px;
  }
`

export default ({ booking, handleClick, error, loading }) => {
  const [enableTicketDownload, setEnableTicketDownload] = useState(false)
  const daysRemaining = moment(booking.departureDate).diff(moment(), 'days')

  useEffect(() => {
    if (daysRemaining <= 25) setEnableTicketDownload(true)
  }, [])

  return (
    <Fragment>
      <Flex>
        {booking.packageType !== 'HOTEL_ONLY' && (
          <Flex>
            {booking.hasThirdPartyFlights ? (
              <p>{getText('selfservice', 'ticket', 'ticketTextD3pf')}</p>
            ) : (
              <p>
                <ReactMarkdown source={getText('selfservice', 'ticket', 'ticketText')} />
              </p>
            )}
            <Button
              className={loading && loading.type === 'ticket' ? 'btn ghost-blue btn-loading' : 'btn btn-function'}
              onClick={() => handleClick('ticket')}
              disabled={!enableTicketDownload || loading}
            >
              <Svg icon="printer"></Svg>&nbsp;&nbsp;
              {booking.hasThirdPartyFlights ? getText('selfservice', 'ticket', 'printTicketD3pf') : getText('selfservice', 'ticket', 'printTicket')}
            </Button>
          </Flex>
        )}
        <Flex>
          {booking.hasThirdPartyFlights ? <p>{getText('selfservice', 'confirm', 'd3pfConfirmationText')}</p> : <p>{getText('selfservice', 'confirm', 'confirmationText')}</p>}
          <Button className={loading && loading.type === 'confirmation' ? 'btn ghost-blue btn-loading' : 'btn btn-function'} onClick={() => handleClick('confirmation')} disabled={loading}>
            <Svg icon="printer"></Svg>&nbsp;&nbsp;
            {getText('selfservice', 'confirm', 'printConfirmation')}
          </Button>
        </Flex>
      </Flex>
      {error && (
        <Fragment>
          <Break />
          <Message error={true}>{error}</Message>
        </Fragment>
      )}
    </Fragment>
  )
}
